import {hotjar} from 'react-hotjar';
import {Config} from "./config";

const hotjarConfig = Config.HOTJAR;

if (!Config.DEV && hotjarConfig && hotjarConfig.hjid && hotjarConfig.hjsv) {
    hotjar.initialize(hotjarConfig.hjid, hotjarConfig.hjsv);
}
